import { ObjectBase } from "./ObjectBase";
export class EventArgs extends ObjectBase {
  static get empty() {
    return this._empty;
  }

}
EventArgs._empty = new EventArgs();
